<template>
<!-- Sidebar -->
<div class="sidebar" id="sidebar">
	<div class="sidebar-inner">
		<vue-custom-scrollbar class="scroll-area"  :settings="settings" @ps-scroll-y="scrollHanle">
		<div id="sidebar-menu" class="sidebar-menu">
			<ul>
				<li class="nav-item nav-profile">
				  <a href="#" class="nav-link">
					<div class="nav-profile-image">
					  <img :src="avatar" alt="profile">

					</div>
					<div class="nav-profile-text d-flex flex-column">
					  <span class="font-weight-bold mb-2">{{name}}</span>
					  <span class="text-white text-small">{{ $t('menu.counselor') }}</span>
					</div>
					<i class="mdi mdi-bookmark-check text-success nav-profile-badge"></i>
				  </a>
				</li>
				<li class="menu-title">
					<span>Main</span>
				</li>
        <li>
          <router-link to="/index"><i class="dkl-icon-datenschutz-person"></i> <span>{{ $t('menu.overview') }}</span></router-link>
        </li>
        <li>
          <router-link to="/gap-list"><i class="dkl-icon-gap"></i> <span>{{ $t('menu.gap_analysis') }}</span></router-link>
        </li>
        <li v-show="aiEnabled">
          <router-link to="/ai-gap-list"><i class="fa-solid fa-scale-unbalanced-flip"></i> <span>{{ $t('menu.ai_gap_analysis') }}</span></router-link>
        </li>
        <li class="submenu">
          <a href="#"><i class="fa fa-tasks"></i> <span>{{ $t('menu.actions') }}</span> <span class="menu-arrow"></span></a>
          <ul class="sub-menus">
            <li><router-link to="/massnahmenplan"><span>{{ $t('menu.action_plan') }}</span></router-link></li>
            <li v-show="aiEnabled"><router-link to="/ai-massnahmenplan"><span>{{ $t('menu.ai_action_plan') }}</span></router-link></li>
            <li><router-link to="/massnahmenplan-calendar-view"><span>{{ $t('menu.action_plan_calendar') }}</span></router-link></li>
          </ul>
        </li>
        <li class="submenu">
          <a href="#"><i class="dkl-icon-vt"></i> <span>{{ $t('menu.vt') }}</span> <span class="menu-arrow"></span></a>
          <ul class="sub-menus">
            <li><router-link to="/vt"><span>{{ $t('menu.vt') }}</span></router-link></li>
            <li><router-link to="/risk-analysis"><span>{{ $t('menu.risk_assessment') }}</span></router-link></li>
          </ul>
        </li>
        <li>
          <router-link to="/vt-selbst"><i class="feather-layers"></i><span>{{ $t('menu.vt_processor') }}</span></router-link>
        </li>
        <li>
          <router-link to="/shared-responsibilty"><i class="feather-database"></i> <span>{{ $t('menu.shared_responsibility') }}</span></router-link>
        </li>
        <li class="submenu">
          <a href="#"><i class="dkl-icon-av"></i> <span>{{ $t('menu.systems') }}</span> <span class="menu-arrow"></span></a>
          <ul class="sub-menus">
            <li><router-link to="/systeme"><span>{{ $t('menu.systems') }}</span></router-link></li>
            <li><router-link to="/systeme-assess"><span>{{ $t('menu.system_assessment') }}</span></router-link></li>
          </ul>
        </li>
        <li class="submenu">
          <a href="#"><i class="dkl-icon-supplier"></i> <span>{{ $t('menu.supplier') }}</span> <span class="menu-arrow"></span></a>
          <ul class="sub-menus">
            <li><router-link to="/dienstleister"><span>{{ $t('menu.supplier') }}</span></router-link></li>
            <li><router-link to="/avv-list">{{ $t('menu.listing') }}</router-link></li>
            <li><router-link to="/avv">{{ $t('menu.dpa_check') }}</router-link></li>
            <li><router-link to="/avv-demo">{{ $t('menu.dpa_check') }} (KI unterstützt)</router-link></li>
            <li v-if="accountName==='1_A_Beispielmandant'"><router-link to="/avv-edit">{{ $t('menu.edit_survey') }}</router-link></li>
          </ul>
        </li>
        <li>
          <router-link to="/incident"><i class="fa fa-ambulance"></i> <span>{{ $t('menu.incidents') }}</span></router-link>
        </li>
        <li>
          <router-link to="/audit"><i class="fa fa-search-plus"></i>  <span>{{ $t('menu.review') }}</span></router-link>
        </li>
        <li class="submenu">
          <a href="#"><i class="dkl-icon-toms"></i> <span>{{ $t('menu.toms') }}</span> <span class="menu-arrow"></span></a>
          <ul class="sub-menus">
            <li><router-link to="/toms-list">{{ $t('menu.listing') }}</router-link></li>
            <li><router-link to="/toms">{{ $t('menu.toms') }}</router-link></li>
            <li v-if="accountName==='1_A_Beispielmandant'"><router-link to="/toms-edit">{{ $t('menu.edit_survey') }}</router-link></li>
          </ul>
        </li>
        <li class="submenu">
          <a href="#"><i class="fa-brands fa-edge-legacy"></i> <span>{{ $t('menu.website_audit') }}</span> <span class="menu-arrow"></span></a>
          <ul class="sub-menus">
            <li><router-link to="/website-audits">{{ $t('menu.audits_listing') }}</router-link></li>
            <li><router-link to="/create-website-audit">{{ $t('menu.start_website_audit') }}</router-link></li>
          </ul>
        </li>
        <li>
          <router-link to="/generate-ds-report"><i class="dkl-icon-report"></i> <span>{{ $t('menu.ds_report') }}</span></router-link>
        </li>
        <li>
          <router-link to="/translator"><i class="fa-solid fa-language fa-sm" aria-hidden="true"></i> <span>{{ $t('menu.translate') }}</span></router-link>
        </li>
        <li>
          <router-link to="/ai-chat"><i class="fa-solid fa-robot" aria-hidden="true"></i> <span>{{ $t('menu.lenz_tech') }}</span></router-link>
        </li>
        <li>
          <a :href="crmLink" target="_blank"><i class="fa fa-external-link"></i> <span>{{ $t('menu.to_crm') }}</span></a>
        </li>
<!--        <li><div class="van-divider"></div></li>-->
<!--        <li>-->
<!--          <router-link to="/risiko"><i class="dkl-icon-risk"></i> <span>{{ $t('menu.risk') }}</span></router-link>-->
<!--        </li>-->
			</ul>
		</div>
	</vue-custom-scrollbar>
	</div>
</div>
<!-- /Sidebar -->
</template>
<script>
	import vueCustomScrollbar from 'vue-custom-scrollbar'
	import "vue-custom-scrollbar/dist/vueScrollbar.css"
  import {mapState} from 'vuex';
  import {crmURL} from "@/utils/request";
   export default {
	   components: {
   vueCustomScrollbar
 },
 mounted() {
	 $('#sidebar-menu a').on('click', function (e) {
	   if ($(this).parent().hasClass('submenu')) {
		 e.preventDefault();
	   }
	   if (!$(this).hasClass('subdrop')) {
		 $('ul', $(this).parents('ul:first')).slideUp(350);
		 $('a', $(this).parents('ul:first')).removeClass('subdrop');
		 $(this).next('ul').slideDown(350);
		 $(this).addClass('subdrop');
	   } else if ($(this).hasClass('subdrop')) {
		 $(this).removeClass('subdrop');
		 $(this).next('ul').slideUp(350);
	   }
	 });
	 $('#sidebar-menu ul li.submenu a.active').parents('li:last').children('a:first').addClass('active').trigger('click');

   },
   computed: {
	   currentpage() {
       return this.$route.path;
     },
     crmLink() {
       return `${crmURL}/stern_des_suedens/crm/mandant/${this.crmId}/change/`
     },
     ...mapState({name: state => state.user.name, crmId: state => state.account.crmID, avatar: state => state.user.avatar, accountName: state => state.account.name, aiEnabled: state => state.account.aiEnabled}),
	 },
 data() {
	 return {
    settings: {
      suppressScrollX: true,
      // Disable custom scrollbar on mobile to use native scrolling
      wheelPropagation: true,
      swipeEasing: true,
      minScrollbarLength: 20
      },
    activeClass: 'active',
   };
         //  isactive : true
 },
  methods: {
     scrollHanle(evt) {
     },
  },
}
</script>
<style>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100dvh - 60px);
  background-color: transparent !important;
  /* Ensure native touch scrolling works if the library fails */
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
  }
.sidebar-menu ul ul a.active {
   color: #fff;
   background-color: #9b3136;
   text-decoration: underline;
}
.sidebar-menu ul li a.active {
   color: #fff;
   background-color: #9b3136;
}
.sidebar-menu i {
  font-size: 18px!important;
}
</style>
